import _ from 'lodash'

export default {
  setPermissions(state, value) {
    state.permissions = value
  },
  setPermissionsPilkiPro(state, value) {
    state.permissionsPilkiPro = value
  },
  setActivePermissionsMap(state, value) {
    state.activePermissionsMap = value
  },
  setActivePermissionsMapPilkiPro(state, value) {
    state.activePermissionsMapPilkiPro = value
  },
  setGroupPermissions(state, permissions) {
    state.groupPermissions = permissions
  },
  setGroupPermissionsPilkiPro(state, value) {
    state.groupPermissionsPilkiPro = value
  },
  setActiveGroupPermissionsMap(state, value) {
    state.activeGroupPermissionsMap = value
  },
  setActiveGroupPermissionsMapPilkiPro(state, value) {
    state.activeGroupPermissionsMapPilkiPro = value
  },
  resetAllRights(state) {
    state.activePermissionsMap = {}

    for (let i = 0; i < state.groupPermissions.length; i++) {
      state.activeGroupPermissionsMap[state.groupPermissions[i].title] = false
    }
  },
  selectAllPermissions(state) {
    const allIds = state.groupPermissions.reduce((acc, cur) => (acc = [...acc, ...cur.permissions.map(x => x.id)]), [])
    state.activePermissionsMap = allIds.reduce((acc, cur) => (acc = { ...acc, [cur]: true }), {})

    for (let i = 0; i < state.groupPermissions.length; i++) {
      state.activeGroupPermissionsMap[state.groupPermissions[i].title] = true
    }
  },
  selectPermission(state, permission) {
    if (permission.id in state.activePermissionsMap) {
      state.activePermissionsMap[permission.id] = !state.activePermissionsMap[permission.id]
    } else {
      state.activePermissionsMap[permission.id] = true
    }

    const groupPermission = _.find(state.groupPermissions, groupPermission => {
      return groupPermission.title == permission.group_permission_title
    })

    if (permission.action === 'bonuses_add') {
      const permissionView = groupPermission.permissions.find(item => item.action === 'bonuses_history')
      if (permissionView) state.activePermissionsMap[permissionView.id] = true
    }

    if (permission.action !== 'view') {
      const permissionView = groupPermission.permissions.find(item => item.action === 'view')
      if (permissionView) state.activePermissionsMap[permissionView.id] = true
    }

    // Get only checked permissions
    const activePermissions = _.filter(groupPermission.permissions, permission => {
      return state.activePermissionsMap[permission.id]
    })

    if (activePermissions.length === groupPermission.permissions.length) {
      state.activeGroupPermissionsMap[groupPermission.title] = true
    } else {
      state.activeGroupPermissionsMap[groupPermission.title] = false
    }
  },
  selectGroupPermission(state, selectedGroupPermission) {
    if (selectedGroupPermission.title in state.activeGroupPermissionsMap) {
      state.activeGroupPermissionsMap[selectedGroupPermission.title] =
        !state.activeGroupPermissionsMap[selectedGroupPermission.title]
    } else {
      state.activeGroupPermissionsMap[selectedGroupPermission.title] = true
    }

    const groupPermission = _.find(state.groupPermissions, groupPermission => {
      return groupPermission.title == selectedGroupPermission.title
    })

    _.forEach(groupPermission.permissions, permission => {
      state.activePermissionsMap[permission.id] = state.activeGroupPermissionsMap[selectedGroupPermission.title]
    })
  },
  selectPermissionPilkiPro(state, permission) {
    if (permission.id in state.activePermissionsMapPilkiPro) {
      state.activePermissionsMapPilkiPro[permission.id] = !state.activePermissionsMapPilkiPro[permission.id]
    } else {
      state.activePermissionsMapPilkiPro[permission.id] = true
    }

    const groupPermissionsPilkiPro = _.find(state.groupPermissionsPilkiPro, groupPermission => {
      return groupPermission.title === permission.group_permission_title
    })

    const activePermissions = _.filter(groupPermissionsPilkiPro.permissions, permission => {
      return state.activePermissionsMapPilkiPro[permission.id]
    })

    if (activePermissions.length === groupPermissionsPilkiPro.permissions.length) {
      state.activeGroupPermissionsMapPilkiPro[groupPermissionsPilkiPro.title] = true
    } else {
      state.activeGroupPermissionsMapPilkiPro[groupPermissionsPilkiPro.title] = false
    }
  },
  selectGroupPermissionPilkiPro(state, selectedGroupPermissionPilkiPro) {
    if (selectedGroupPermissionPilkiPro.title in state.activeGroupPermissionsMapPilkiPro) {
      state.activeGroupPermissionsMapPilkiPro[selectedGroupPermissionPilkiPro.title] =
        !state.activeGroupPermissionsMapPilkiPro[selectedGroupPermissionPilkiPro.title]
    } else {
      state.activeGroupPermissionsMapPilkiPro[selectedGroupPermissionPilkiPro.title] = true
    }

    const groupPermission = state.groupPermissionsPilkiPro.find(groupPermission => {
      return groupPermission.title === selectedGroupPermissionPilkiPro.title
    })

    _.forEach(groupPermission.permissions, permission => {
      state.activePermissionsMapPilkiPro[permission.id] =
        state.activeGroupPermissionsMapPilkiPro[selectedGroupPermissionPilkiPro.title]
    })
  },
}
